export const iconFontAwesomeDisasterCrisisChildCombatant = (
	<i className="fa-solid fa-child-combatant"></i>
);
